import React from "react";

const education = [
  {
    degree: "B.S. in Computer Science",
    university: "California State University, San Bernardino",
    year: "Sep 1999 - Dec 2003",
    detail: "GPA: 3.3",
  },
  {
    degree: "High school w/honors + A.P.",
    university: "San Gorgonio High School",
    year: " Sep 1986 - Jun 1990",
    detail: "GPA: 3.4",
  },
];

const Education = () => {
  return (
    <div className="timeline" id="education">
      <div className="timeline-container">

        {education.map((item, index) => (
          <div key={index} className={`timeline-row ${index%2===0 ? "timeline-left" : "timeline-right" }`}>
            <div className="timeline-content active">
            <h3 className="timeline-heading">{item.degree}</h3>
              <p className="timeline-subheading">{item.university}</p>
              <p className="timeline-duration">{item.year}</p>
              <p className="timeline-detail">{item.detail}</p>
            </div>

            <div className="timeline-content" />
          </div>
        ))}
      </div>
      <div className="timneline-spine"> </div>
    </div>
  );
}

export default Education;
